import { memo, useMemo } from "react";
import { Box, Typography, IconButton, Button, Stack, Divider, Avatar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getAllFields } from "../../../../../hooks/useTableColumnsConfig";

const ConditionalsList = ({ conditionals, onClose, handleAddConditional, handleViewConditional }) => {
  const columnHeaders = useMemo(() => getAllFields(), []);

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 2 }}>
        <Typography variant="h6">Conditional</Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>

      <Box sx={{ flexGrow: 1, overflowY: "auto", px: 2 }}>
        <Stack spacing={1.5}>
          {conditionals.map((conditional) => {
            const column = columnHeaders.find((col) => col.key === conditional.column);
            const columnLabel = column ? column.label : conditional.column;
            const conditionsCount = conditional.conditions.length;
            const displayText = `${columnLabel} (${conditionsCount} condition${conditionsCount > 1 ? "s" : ""})`;
            const colors = conditional.conditions.map((cond) => cond.color);

            return (
              <Box
                key={conditional.id}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  p: 1.5,
                  backgroundColor: "grey.100",
                  borderRadius: 1,
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "grey.200",
                  },
                }}
                onClick={() => handleViewConditional(conditional.id)}
              >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, flex: 1 }}>
                  <Typography variant="body2">{displayText}</Typography>
                  {colors.length > 0 && (
                    <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
                      {colors.map((color, idx) => (
                        <Avatar
                          key={idx}
                          sx={{
                            width: 12,
                            height: 12,
                            bgcolor: color,
                            border: "1px solid",
                            borderColor: "divider",
                          }}
                        >
                          {" "}
                        </Avatar>
                      ))}
                    </Box>
                  )}
                </Box>
                <Typography variant="body2" color="text.secondary">
                  View
                </Typography>
              </Box>
            );
          })}
        </Stack>
      </Box>

      <Divider />

      <Box sx={{ p: 2 }}>
        <Button fullWidth variant="contained" onClick={handleAddConditional} color="primary" disableElevation>
          Add new conditional
        </Button>
      </Box>
    </>
  );
};

export default memo(ConditionalsList);
